export const colors = {
  primary: "#7B92FF",
  redd: "#FF2798",
  slate: "#F9F9F9",
  grey_soft: "#EEEEEE",
  grey_medium: "#E9E9E9",
  grey_hard: "#BFBFBF",
  grey_hard2: "#A8A8A8",
  grey_hard3: "#707070",
  black: "#000",
  white: "#fff",
  blue: "#7ACCEC",
  green: "#9BFF9F",
  orange: "#FFB74D",
  yellow: "#FFEB3B",
  indigo: "#7A88EC",
  red: "#f44336",
  black_75: "#4D4D4D",
  black_50: "#7F7F7F",
  black_25: "#BFBFBF",
  black_15: "#D6D6D6",
  black_10: "#E0E0E0",
  black_7: "#E8E8E8",
  black_5: "#F2F2F2",
  white_75: "#FFFFFFBF",
  white_50: "#FFFFFF80",
  white_25: "#FFFFFF40",
  white_15: "#FFFFFF26",
  indigo_soft: "#dadafe",
  indigo_hard: "#7A88EC",
  orange_soft: "#ffeddd",
  orange_hard: "#FFB74D",
  blue_soft: "#d9e9ff",
  blue_hard: "#7ACCEC",
  green_soft: "#d9ffe0",
  green_hard: "#9BFF9F",
  transparent: "transparent",
  // make a dict of colors with the same name as the color but in lowercase
  folder_status_bg: {
    preinspection: "#E9E9E9",
    inspection: "#7B92FF",
    redaction: "#000",
    conforme: "#1DE59F",
    nonconforme: "#7C7C7C",
  },
  folder_status_color: {
    preinspection: "#7C7C7C",
    inspection: "#F8F8F8",
    redaction: "#F8F8F8",

    conforme: "#F8F8F8",
    nonconforme: "#F8F8F8",
  },
  calibration_red: "#FFE4E4",
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
};

export const fontSizes = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
};
